import React from 'react';

const EmailIcon = (): JSX.Element => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M11.9994,1.33l11.8529,7.3911H.1465L11.9994,1.33ZM24,20.5238h-.0012c0,1.1855-.9608,2.1462-2.1462,2.1462H2.1462c-1.1855,0-2.1462-.9608-2.1462-2.1462v-11.3324c0-.1254.0128-.2473.0337-.3671l11.3248,7.0617c.0139.0087.0287.0146.043.0226.015.0083.0302.0163.0454.0239.08.0413.1624.0745.2466.0963.0087.0024.0174.0035.026.0055.0924.0218.186.0354.2795.0354h.002c.0935,0,.1871-.0132.2795-.0354.0087-.0021.0174-.0031.026-.0055.0841-.0218.1662-.055.2466-.0963.0152-.0076.0304-.0156.0454-.0239.0142-.008.0291-.0139.043-.0226l11.3248-7.0617c.0208.1198.0337.2414.0337.3671v11.3324h0Z"
      vectorEffect="non-scaling-stroke"
    />
  </svg>
);

export default EmailIcon;
